import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import EmptyData from "../../Global/EmptyData";
import SendExcelData from "../../Admin/OrderList/SendExcelData";
import CustomDateRangePicker from "../../Global/CustomDateRangePicker";
import Select from "react-select";
import useSubscriptionOrders from "./useSubscriptionOrders";

const SubscriptionOrders = () => {
  const {
    date,
    getRow,
    refetch,
    planList,
    storeList,
    isLoading,
    modalClose,
    statusList,
    isFetching,
    planListObj,
    storeListObj,
    handleSearch,
    handleSort,
    statusListObj,
    showEditModal,
    sendExcelData,
    handlePageSize,
    isExcelLinkSend,
    handlePagination,
    handleDateChange,
    handleClearClick,
    handleChangePlan,
    handleChangeStore,
    paginationOptions,
    handleChangeStatus,
    handleExcelDownload,
    handleDateRangeChange,
    subscriptionOrdersList,
    handleEditColumnsClick,
    subscriptionOrdersState,
    updateSubscriptionOrdersFields,
  } = useSubscriptionOrders();

  return (
    <>
      <HeadingGroup title="Subscription (Orders)" className={`pro-mb-4`}>
        <div className="col dropdown-filter pro-d-flex">
          <button
            className={`pro-btn pro-btn-outline-primary no-wrap pro-items-center pro-ms-3`}
            type="submit"
            onClick={handleExcelDownload}
          >
            <span className="material-symbols-outlined x4">download</span>
            <span>{`Export Data`}</span>
          </button>
        </div>
      </HeadingGroup>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={<span className="material-symbols-outlined"> search </span>}
          handleClear={handleClearClick}
          searchInputProps={{ value: subscriptionOrdersState?.search }}
          handleActionClick={handleEditColumnsClick}
          searchable={true}
          dropDownFilter={
            <>
              <div className="col-auto">
                <CustomDateRangePicker
                  defaultDateRange={date}
                  handleDateRangeChange={handleDateRangeChange}
                />
              </div>
              <div className="col-auto dropdown-filter">
                <Select
                  value={storeListObj}
                  onChange={handleChangeStore}
                  options={storeList}
                  placeholder="Select Store"
                  classNamePrefix={`pro-input`}
                  className={`pro-input lg search-filter-select`}
                  isClearable
                />
              </div>
              <div className="col-auto dropdown-filter">
                <Select
                  value={planListObj}
                  onChange={handleChangePlan}
                  options={planList}
                  placeholder="Select Plan"
                  classNamePrefix={`pro-input`}
                  className={`pro-input lg search-filter-select`}
                  isClearable
                />
              </div>
              {/* Left unset by default: a plan is spent when the order is placed, so the
                  orders still being prepared belong on the screen unless asked otherwise. */}
              <div className="col-auto dropdown-filter">
                <Select
                  value={statusListObj}
                  onChange={handleChangeStatus}
                  options={statusList}
                  placeholder="Select Status"
                  classNamePrefix={`pro-input`}
                  className={`pro-input lg search-filter-select`}
                  isClearable
                />
              </div>
            </>
          }
          onDateChange={handleDateChange}
          initialDateRange={date}
        />
        {subscriptionOrdersList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={subscriptionOrdersList?.data?.result || []}
            uniqueID={"id"}
            fields={subscriptionOrdersList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={subscriptionOrdersState?.clearSelection}
            perpage={subscriptionOrdersState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={false}
            showCheckBox={false}
          />
        )}

        {subscriptionOrdersList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={subscriptionOrdersState?.currentPage}
            totalPageCount={Math.ceil(
              subscriptionOrdersState?.totalCount /
                subscriptionOrdersState?.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === subscriptionOrdersState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={subscriptionOrdersList?.data?.fields || []}
              moduleId={subscriptionOrdersList?.data?.module_id}
              updateData={updateSubscriptionOrdersFields}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={subscriptionOrdersState.excelSendModal}
          handleClose={handleExcelDownload}
          title={`Send Excel Download Link`}
          backdrop="static"
        >
          <div className="pro-m-5">
            <SendExcelData
              isBestSeller
              handleCloseModal={modalClose}
              sendExcelData={sendExcelData}
              isExcelLinkSend={isExcelLinkSend}
            />
          </div>
        </ModalLayout>
      </div>
    </>
  );
};

export default SubscriptionOrders;
